import Alpine from "alpinejs";
import { filestackPicker } from "../uploader";

const FILESTACK_BASE_URL = "https://cdn.filestackcontent.com/";

// For height and width we use double the size of the square (~71px) for retina displays
const PREVIEW_HEIGHT = 150;
const PREVIEW_WIDTH = 150;

Alpine.data(
  "single_file_input",
  ({
    s3PathPrefix: s3PathPrefix,
    accept: accept,
    file: file,
    maxKilobyteSize: maxKilobyteSize,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
  }) => ({
    file: file,
    accept: accept,
    // Intented as a fallback flag if failures occur in previewing
    iconPreview: false,
    loading: false,
    hoverPreview: false,
    get expectsImage() {
      return /^image\/(\*|[a-z]*)$/.test(this.accept);
    },
    pickFile() {
      filestackPicker({
        path: s3PathPrefix,
        accept: accept,
        maxFiles: 1,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        maxSingleFileSize: maxKilobyteSize ? 1024 * maxKilobyteSize : null,
      })
        .then(({ filesUploaded: [file] }) => {
          this.loading = true;
          this.file = {
            url: file.url,
            mime: file.mimetype,
            filename: file.filename,
            size: file.size,
            path: file.uri,
          };
          this.iconPreview = false;
        })
        .catch((error) => console.error(error));
    },
    trash() {
      // Though this is set to null the form will send an empty string
      // On Elixir side use `Digiforma.ControllerUtils.clean_nested_inputs/2` to clean the value before giving it to a changeset
      this.file = null;
    },
    previewUrl(format) {
      if (!this.file || !this.file.url) {
        return;
      }

      // This *magic* url creates a picture preview url
      // See https://www.filestack.com/features/processing/file-conversion for full list of supported file type
      // If by any chance the conversion fails a 500 is returned by filestack will trigger the `onPreviewLoadFailed` function
      // Preview url are cached for 30 days by default
      return this.file.url.replace(
        FILESTACK_BASE_URL,
        `${FILESTACK_BASE_URL}/output=f:${format},q:95,t:true/resize=w:${PREVIEW_WIDTH},h:${PREVIEW_HEIGHT},f:clip/`
      );
    },
    onPreviewLoadFailed() {
      console.error("Could not load preview, falling back to icon.");
      this.iconPreview = true;
    },
    onPreviewLoaded() {
      this.loading = false;
    },
  })
);
